import React, { Component } from 'react'
import { connect } from 'react-redux'
import JHPublishes from '../../components/JH/JHPublishes'
import { showDialog } from '../../redux/actions/MainDialog'
import HistogramC from '../HistogramC'

class JHPublishesPC extends Component {
    showMessageDialog = (title, content) => {
        const {dispatch} = this.props

        dispatch(showDialog(title, content))
    }

    render() {
        const { isAdmin, isJHAdmin } = this.props

        return (
            <>
                {(isAdmin || isJHAdmin)?
                <JHPublishes showMessageDialog={this.showMessageDialog}/>
                :<HistogramC histogramType={'main'} />}
            </>
        )
    }
}

function mapStateToProps(state) {
    const { isAuthed, userInfo } = state.authUser;

    const isAdmin = (userInfo && userInfo.isAdmin)
    const isJHAdmin = (userInfo && userInfo.isJHAdmin)

    return {
        isAuthed, isAdmin, isJHAdmin
    }
}

export default connect(mapStateToProps)(JHPublishesPC)